import React, { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from './../../s3Func/s3Download';
import { API } from 'aws-amplify';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Practice.css';
import { useNavigate } from 'react-router-dom';
import VideoWebcamRecorder from '../../Unit2/Day4Practice/Recorder';
import loading from "./../../loading-gif-png-5.gif"
import { sleep } from '../../utils/index';

/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const UnderstandFeelingsPractice = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [practiceVideo, setPracticeVideo] = useState(false);
  const [practice, setPractice] = useState(false);
  const [displayPracticeVideo, setDisplayPracticeVideo] = useState('');
  const [question, setQuestion] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [voiceAudio, setVoiceAudio] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const talkAudioRef = useRef(null);
  const expectedTalkSrcRef = useRef('');
  const animalAudioRef = useRef(null);
  const expectedAnimalSrcRef = useRef('');
  const [who, setWho] = useState('the crab');
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [selectImage, setSelectImage] = useState(null);
  const [matchGame1, setMatchGame1] = useState(false);
  const [changeAnswer, setChangeAnswer] = useState(false);
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [option3, setOption3] = useState('');
  const [answerkey, setAnswerkey] = useState(null);
  const [check, setCheck] = useState(false);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Exit = generateImageUrl('images/Images/close.png');
  const crab_calm = generateImageUrl('images/Module11Images/CharacterScene_Crab_Calm.png');
  const crab_confident = generateImageUrl('images/Module11Images/CharacterScene_Crab_Confident@2x.png');
  const crab_happy = generateImageUrl('images/Module11Images/CharacterScene_Crab_Happy@2x.png');
  const crab_mad = generateImageUrl('images/Module11Images/CharacterScene_Crab_Mad@2x.png');
  const crab_sad = generateImageUrl('images/Module11Images/CharacterScene_Crab_Sad@2x.png');
  const crab_nervous = generateImageUrl('images/Module11Images/CharacterScene_Crab_Nervous@2x.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const Mad_Calm = generateImageUrl('images/Module12Images/Practice_Puzzel_Mad_Calm@2x.png');
  const Nervous_Confident = generateImageUrl('images/Module12Images/Practice_Puzzel_Nervous_Confident@2x.png');
  const Sad_happy = generateImageUrl('images/Module12Images/Practice_Puzzel_Sad_happy@2x.png');

  const [keyword, setKeyword] = useState('');
  const [ending, setEnding] = useState(false);
  const [close, setClose] = useState(false);

  const [practiceReview, setPracticeReview] = useState(false);
  const [displayCamera, setDisplayCamera] = useState(false);
  const [displayConversation, setDisplayConversation] = useState(false);
  const [displayInfluecer, setDisplayInfluecer] = useState(false);
  const [displayAfterVideo, setDisplayAfterVideo] = useState(false);
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [conversation3, setConversation3] = useState(false);
  const [conversation4, setConversation4] = useState(false);
  const [conversation5, setConversation5] = useState(false);
  const [reviewVideo, setReviewVideo] = useState('');
  const [playVideo, setPlayVideo] = useState('');
  const [text, setText] = useState('');
  const [voice, setVoice] = useState('');
  const [questionVideo, setQuestionVideo] = useState('');
  const [animateAnimal, setAnimateAnimal] = useState('');
  const [greeting, setGreeting] = useState('');
  const [greetingRespond, setGreetingRespond] = useState('');
  const [acknowledge, setAcknowledge] = useState('');
  const [influencerVideo, setInfluencerVideo] = useState('');
  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };
  const videoPlayer1 = {
    width: '370px',
    height: '655px',
    zIndex: 20,
  };

  // Generate a random number based on the arraysize passed in.
  function getRandomInt(arraysize) {
    return Math.floor(Math.random() * Math.floor(arraysize));
  }

  // Answers that can be selected by the user. Each has an associated image and sound file.
  // Answers are grouped by category (Mad, Calm, etc.)
  const madAnwsers = [{
    text: 'I break my toy',
    url: 'appfiles/understand_feelings/prompt_break_toy.mp3',
    answer: 'appfiles/understand_feelings/example_break_toy.mp3',
    img: generateImageUrl('images/Module12Images/practice/I break my toy.png'),
    feeling: 'mad',
  }, {
      text: 'I am hungry',
      url: 'appfiles/understand_feelings/prompt_hungry.mp3',
      answer: 'appfiles/understand_feelings/example_hungry.mp3',
      img: generateImageUrl('images/Module12Images/practice/I am hungry.png'),
      feeling: 'mad',
  }, {
      text: 'I cannot play my game',
      url: 'appfiles/understand_feelings/prompt_cannot_play_game.mp3',
      answer: 'appfiles/understand_feelings/example_cannot_play_game.mp3',
      img: generateImageUrl('images/Module12Images/practice/I can_t play my game.png'),
      feeling: 'mad',
  }, {
      text: 'I am tired',
      url: 'appfiles/understand_feelings/prompt_tired.mp3',
      answer: 'appfiles/understand_feelings/example_tired.mp3',
      img: generateImageUrl('images/Module12Images/practice/I am tired.png'),
      feeling: 'mad',
  }, ];
  const calmAnwsers = [{
      text: 'I take a nap',
      url: 'appfiles/understand_feelings/prompt_nap.mp3',
      ending: 'appfiles/understand_feelings/model_nap.mp3',
      answer: 'appfiles/understand_feelings/example_nap.mp3',
      img: generateImageUrl('images/Module12Images/practice/I take a nap.png'),
      feeling: 'calm',
  }, {
      text: 'I listen to music',
      url: 'appfiles/understand_feelings/prompt_listen_music.mp3',
      ending: 'appfiles/understand_feelings/model_listen_music.mp3',
      answer: 'appfiles/understand_feelings/example_listen_music.mp3',
      img: generateImageUrl('images/Module12Images/practice/I listen to music.png'),
      feeling: 'calm',
  }, {
      text: 'I get to eat',
      url: 'appfiles/understand_feelings/prompt_eat.mp3',
      ending: 'appfiles/understand_feelings/model_eat.mp3',
      answer: 'appfiles/understand_feelings/example_eat.mp3',
      img: generateImageUrl('images/Module12Images/practice/I get to eat.png'),
      feeling: 'calm',
  }, {
      text: 'I take deep breaths',
      url: 'appfiles/understand_feelings/prompt_deep_breath.mp3',
      ending: 'appfiles/understand_feelings/model_deep_breath.mp3',
      answer: 'appfiles/understand_feelings/example_deep_breath.mp3',
      img: generateImageUrl('images/Module12Images/practice/I take deep breaths.png'),
      feeling: 'calm',
  }, ];
  const nervousAnwsers = [{
      text: 'it is dark',
      url: 'appfiles/understand_feelings/prompt_dark.mp3',
      answer: 'appfiles/understand_feelings/example_dark.mp3',
      img: generateImageUrl('images/Module12Images/practice/it is dark.png'),
      feeling: 'nervous',
  }, {
      text: 'I have a test',
      url: 'appfiles/understand_feelings/prompt_test.mp3',
      answer: 'appfiles/understand_feelings/example_test.mp3',
      img: generateImageUrl('images/Module12Images/practice/I have a test.png'),
      feeling: 'nervous',
  }, {
      text: 'something is new to me',
      url: 'appfiles/understand_feelings/prompt_something_is_new.mp3',
      answer: 'appfiles/understand_feelings/example_something_is_new.mp3',
      img: generateImageUrl('images/Module12Images/practice/something is new to me.png'),
      feeling: 'nervous',
  }, {
    text: 'I make a mistake',
    url: 'appfiles/understand_feelings/prompt_mistake.mp3',
    answer: 'appfiles/understand_feelings/example_mistake.mp3',
    img: generateImageUrl('images/Module12Images/practice/I make a mistake.png'),
    feeling: 'nervous',
  },];
  const confidentAnwsers = [{
      text: 'I stand tall',
      url: 'appfiles/understand_feelings/prompt_stand_tall.mp3',
      ending: 'appfiles/understand_feelings/model_stand_tall.mp3',
      answer: 'appfiles/understand_feelings/example_stand_tall.mp3',
      img: generateImageUrl('images/Module12Images/practice/I stand tall.png'),
      feeling: 'confident',
  }, {
      text: 'I do a good job',
      url: 'appfiles/understand_feelings/prompt_good_job.mp3',
      ending: 'appfiles/understand_feelings/model_good_job.mp3',
      answer: 'appfiles/understand_feelings/example_good_job.mp3',
      img: generateImageUrl('images/Module12Images/practice/I do a good job.png'),
      feeling: 'confident',
  }, {
      text: 'I work hard',
      url: 'appfiles/understand_feelings/prompt_work_hard.mp3',
      ending: 'appfiles/understand_feelings/model_work_hard.mp3',
      answer: 'appfiles/understand_feelings/example_work_hard.mp3',
      img: generateImageUrl('images/Module12Images/practice/I work hard.png'),
      feeling: 'confident',
  }, {
      text: 'I have my stuffed animal',
      url: 'appfiles/understand_feelings/prompt_stuffed_animal.mp3',
      ending: 'appfiles/understand_feelings/model_stuffed_animal.mp3',
      answer: 'appfiles/understand_feelings/example_stuffed_animal.mp3',
      img: generateImageUrl('images/Module12Images/practice/I have my stuffed animal.png'),
      feeling: 'confident',
  }, ];
  const sadAnwsers = [{
      text: 'I hurt my knee',
      url: 'appfiles/understand_feelings/prompt_hurt_knee.mp3',
      answer: 'appfiles/understand_feelings/example_hurt_knee.mp3',
      img: generateImageUrl('images/Module12Images/practice/I hurt my knee.png'),
      feeling: 'sad',
  }, {
      text: 'I feel like I dissapoint others',
      url: 'appfiles/understand_feelings/prompt_dissapoint.mp3',
      answer: 'appfiles/understand_feelings/example_mistake.mp3',
      img: generateImageUrl('images/Module12Images/practice/I feel like I disappoint others.png'),
      feeling: 'sad',
  }, {
      text: 'I cannot play outside',
      url: 'appfiles/understand_feelings/prompt_cannot_play_outside.mp3',
      answer: 'appfiles/understand_feelings/example_cannot_play_outside.mp3',
      img: generateImageUrl('images/Module12Images/practice/I cannot play outside.png'),
      feeling: 'sad',
  }, {
      text: 'I frown',
      url: 'appfiles/understand_feelings/prompt_frown.mp3',
      answer: 'appfiles/understand_feelings/example_frown.mp3',
      img: generateImageUrl('images/Module12Images/practice/I frown.png'),
      feeling: 'sad',
  }, ];
  const happyAnwsers = [{
      text: 'I make a new friend',
      url: 'appfiles/understand_feelings/prompt_new_friend.mp3',
      ending: 'appfiles/understand_feelings/model_new_friend.mp3',
      answer: 'appfiles/understand_feelings/example_new_friend.mp3',
      img: generateImageUrl('images/Module12Images/practice/I make a new friend.png'),
      feeling: 'happy',
  }, {
      text: 'I say sorry',
      url: 'appfiles/understand_feelings/prompt_sorry.mp3',
      ending: 'appfiles/understand_feelings/model_sorry.mp3',
      answer: 'appfiles/understand_feelings/example_sorry.mp3',
      img: generateImageUrl('images/Module12Images/practice/I say sorry.png'),
      feeling: 'happy',
  }, {
      text: 'I play outside',
      url: 'appfiles/understand_feelings/prompt_play_outside.mp3',
      ending: 'appfiles/understand_feelings/model_play_outside.mp3',
      answer: 'appfiles/understand_feelings/example_play_outside.mp3',
      img: generateImageUrl('images/Module12Images/practice/I play outside.png'),
      feeling: 'happy',
  }, {
      text: 'I smile',
      url: 'appfiles/understand_feelings/prompt_smile.mp3',
      ending: 'appfiles/understand_feelings/model_smile.mp3',
      answer: 'appfiles/understand_feelings/example_smile.mp3',
      img: generateImageUrl('images/Module12Images/practice/I smile.png'),
      feeling: 'happy',
  }, ];

  // Helper to request playing an animal voice, restarting if same src
  const playAnimalVoice = useCallback(async (src, restartIfSame = true) => {
    const el = animalAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedAnimalSrcRef.current = src;
    if (el && same) {
        if (!restartIfSame) return;
        try {
            el.pause();
            el.currentTime = 0;
            await el.play();
        } catch (e) {
            const msg = String(e && e.message ? e.message : e);
            if (!msg.includes('interrupted by a new load request')) {
                console.log('animal audio replay failed', e);
            }
        }
    } else {
        setAnimalVoice(src);
    }
    setDisplayAnimal(true);
    // Ensure audio is allowed to start even if the image onLoad doesn't fire (same src or cached image)
    setDisplayAudio(true);
}, []);

  // Helper to request playing the animalTalk voice audio, restarting if same src
  const playVoiceAudio = useCallback(async (src, restartIfSame = true) => {
    const el = talkAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedTalkSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try {
        el.pause();
        el.currentTime = 0;
        await el.play();
      } catch (e) {
        const msg = String(e && e.message ? e.message : e);
        if (!msg.includes('interrupted by a new load request')) {
          // eslint-disable-next-line no-console
          console.log('animalTalk audio replay failed', e);
        }
      }
    } else {
      setVoiceAudio(src);
    }
  }, []);

  // Kick playback when animalTalk is requested and a voice source is set
  useEffect(() => {
    if (!animalTalk) return;
    const el = talkAudioRef.current;
    if (!el || !el.src) return;
    if (!el.paused) return;
    el.currentTime = 0;
    el.play().catch(() => {});
  }, [animalTalk, voiceAudio]);

  useEffect(() => {
    if (!displayAudio) return;
    const el = animalAudioRef.current;
    if (!el || !el.src) return;
    if (!el.paused) return;
    el.currentTime = 0;
    el.play().catch(() => {});
}, [displayAudio]);

  // Gets the gifs that allow the crab to talk
  useEffect(() => {
    setIntroSound(getVideo('appfiles/understand_feelings/choose_feelings.mp3', login));
  }, []);

  // Decide which video to show based on the day
  useEffect(() => {
    if(props.unit4){
      setDisplayPracticeVideo(props.reviewVideo);
      setPracticeVideo(true);
    }
    else{
      switch (props.module.currentday) {
        case 1:
          setDisplayPracticeVideo('667edbb5ac1cffad3c810308bf6a/480.m3u8');
          setPracticeVideo(true);
          break;
        case 2:
          setDisplayPracticeVideo('548281ea758c1f7b2abd75277f16/480.m3u8');
          setPracticeVideo(true);
          break;
        case 3:
          setDisplayPracticeVideo('ffd3888e7c3230ef8580ad96fa29/480.m3u8');
          setPracticeVideo(true);
          break;
        default:
          setPractice(true);
          setQuestion(true);
          break;
      }
    }
  }, []);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: "practice_understand_feelings",
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 2 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Sets up the game by selecting which possible answers to display in what order based on the current feeling.
  async function setupGame(feeling) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    setCheck(false);
    setQuestion(false);
    setIntroSound('');
    setAnswerkey(null);
    setChangeAnswer('______');
    setPractice(false);
    setMatchGame1(true);
    let number = 0;
    let num1 = 0;
    let num2 = 0;
    let numArray = [];
    let allAnwsers = [];
    switch (feeling) {
      case 'nervous':
        setSelectImage(crab_nervous);
        allAnwsers = Array.prototype.concat.apply(
          [],
          [calmAnwsers, confidentAnwsers, happyAnwsers]
        );
        number = getRandomInt(nervousAnwsers.length);
        num1 = getRandomInt(allAnwsers.length);
        while (nervousAnwsers[number] === allAnwsers[num1]) {
          num1 = getRandomInt(allAnwsers.length);
        }
        num2 = getRandomInt(allAnwsers.length);
        while (
          nervousAnwsers[number] === allAnwsers[num2] ||
          allAnwsers[num1] === allAnwsers[num2]
        ) {
          num2 = getRandomInt(allAnwsers.length);
        }
        numArray = [nervousAnwsers[number], allAnwsers[num1], allAnwsers[num2]];
        break;
      case 'confident':
        setSelectImage(crab_confident);
        allAnwsers = Array.prototype.concat.apply(
          [],
          [madAnwsers, nervousAnwsers, sadAnwsers]
        );
        number = getRandomInt(confidentAnwsers.length);
        num1 = getRandomInt(allAnwsers.length);
        while (confidentAnwsers[number] === allAnwsers[num1]) {
          num1 = getRandomInt(allAnwsers.length);
        }
        num2 = getRandomInt(allAnwsers.length);
        while (
          confidentAnwsers[number] === allAnwsers[num2] ||
          allAnwsers[num1] === allAnwsers[num2]
        ) {
          num2 = getRandomInt(allAnwsers.length);
        }
        numArray = [
          confidentAnwsers[number],
          allAnwsers[num1],
          allAnwsers[num2],
        ];
        break;
      case 'nervous_confident':
        setSelectImage(crab_confident);
        setWho('you feel');
        number = getRandomInt(confidentAnwsers.length);
        num1 = getRandomInt(confidentAnwsers.length);
        while (number === num1) {
          num1 = getRandomInt(confidentAnwsers.length);
        }
        num2 = getRandomInt(confidentAnwsers.length);
        while (number === num2 || num1 === num2) {
          num2 = getRandomInt(confidentAnwsers.length);
        }
        numArray = [
          confidentAnwsers[number],
          confidentAnwsers[num1],
          confidentAnwsers[num2],
        ];
        break;
      case 'sad':
        setSelectImage(crab_sad);
        allAnwsers = Array.prototype.concat.apply(
          [],
          [
            calmAnwsers,
            confidentAnwsers,
            happyAnwsers,
          ]
        );
        number = getRandomInt(sadAnwsers.length);
        num1 = getRandomInt(allAnwsers.length);
        while (sadAnwsers[number] === allAnwsers[num1]) {
          num1 = getRandomInt(allAnwsers.length);
        }
        num2 = getRandomInt(allAnwsers.length);
        while (
          sadAnwsers[number] === allAnwsers[num2] ||
          allAnwsers[num1] === allAnwsers[num2]
        ) {
          num2 = getRandomInt(allAnwsers.length);
        }
        numArray = [sadAnwsers[number], allAnwsers[num1], allAnwsers[num2]];
        break;
      case 'happy':
        setSelectImage(crab_happy);
        allAnwsers = Array.prototype.concat.apply(
          [],
          [
            madAnwsers,
            nervousAnwsers,
            sadAnwsers,
          ]
        );
        number = getRandomInt(happyAnwsers.length);
        num1 = getRandomInt(allAnwsers.length);
        while (happyAnwsers[number] === allAnwsers[num1]) {
          num1 = getRandomInt(allAnwsers.length);
        }
        num2 = getRandomInt(allAnwsers.length);
        while (
          happyAnwsers[number] === allAnwsers[num2] ||
          allAnwsers[num1] === allAnwsers[num2]
        ) {
          num2 = getRandomInt(allAnwsers.length);
        }
        numArray = [happyAnwsers[number], allAnwsers[num1], allAnwsers[num2]];
        break;
      case 'sad_happy':
        setSelectImage(crab_happy);
        setWho('you feel');
        number = getRandomInt(happyAnwsers.length);
        num1 = getRandomInt(happyAnwsers.length);
        while (number === num1) {
          num1 = getRandomInt(happyAnwsers.length);
        }
        num2 = getRandomInt(happyAnwsers.length);
        while (number === num2 || num1 === num2) {
          num2 = getRandomInt(happyAnwsers.length);
        }
        numArray = [
          happyAnwsers[number],
          happyAnwsers[num1],
          happyAnwsers[num2],
        ];
        break;
      case 'mad':
        setSelectImage(crab_mad);
        allAnwsers = Array.prototype.concat.apply(
          [],
          [
            calmAnwsers,
            confidentAnwsers,
            happyAnwsers,
          ]
        );
        number = getRandomInt(madAnwsers.length);
        num1 = getRandomInt(allAnwsers.length);
        while (madAnwsers[number] === allAnwsers[num1]) {
          num1 = getRandomInt(allAnwsers.length);
        }
        num2 = getRandomInt(allAnwsers.length);
        while (
          madAnwsers[number] === allAnwsers[num2] ||
          allAnwsers[num1] === allAnwsers[num2]
        ) {
          num2 = getRandomInt(allAnwsers.length);
        }
        numArray = [madAnwsers[number], allAnwsers[num1], allAnwsers[num2]];
        break;
      case 'calm':
        setSelectImage(crab_calm);
        allAnwsers = Array.prototype.concat.apply(
          [],
          [
            madAnwsers,
            nervousAnwsers,
            sadAnwsers,
          ]
        );
        number = getRandomInt(calmAnwsers.length);
        num1 = getRandomInt(allAnwsers.length);
        while (calmAnwsers[number] === allAnwsers[num1]) {
          num1 = getRandomInt(allAnwsers.length);
        }
        num2 = getRandomInt(allAnwsers.length);
        while (
          calmAnwsers[number] === allAnwsers[num2] ||
          allAnwsers[num1] === allAnwsers[num2]
        ) {
          num2 = getRandomInt(allAnwsers.length);
        }
        numArray = [calmAnwsers[number], allAnwsers[num1], allAnwsers[num2]];
        break;
      case 'mad_calm':
        setSelectImage(crab_calm);
        setWho('you feel');
        number = getRandomInt(calmAnwsers.length);
        num1 = getRandomInt(calmAnwsers.length);
        while (number === num1) {
          num1 = getRandomInt(calmAnwsers.length);
        }
        num2 = getRandomInt(calmAnwsers.length);
        while (number === num2 || num1 === num2) {
          num2 = getRandomInt(calmAnwsers.length);
        }
        numArray = [calmAnwsers[number], calmAnwsers[num1], calmAnwsers[num2]];
        break;
      default:
        break;
    }
    await sleep(500);
    // Sets the crab video and audio thatt should play based on the emotion
    numArray = numArray
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);

    if (feeling === 'nervous_confident') {
      setKeyword('confident');
      setIntroSound(getVideo('appfiles/understand_feelings/student_confident.mp3', login));
      setQuestion(true);
      setEnding(true);
    } else if (feeling === 'sad_happy') {
      setKeyword('happy');
      setIntroSound(getVideo('appfiles/understand_feelings/student_happy.mp3', login));
      setQuestion(true);
      setEnding(true);
    } else if (feeling === 'mad_calm') {
      setKeyword('calm');
      setIntroSound(getVideo('appfiles/understand_feelings/student_calm.mp3', login));
      setQuestion(true);
      setEnding(true);

    } else {
      setKeyword(feeling);
      setIntroSound(getVideo(`appfiles/understand_feelings/crab_${feeling}.mp3`, login));
      setQuestion(true);

    }

    setOption1(numArray[0]);

    setOption2(numArray[1]);

    setOption3(numArray[2]);

  }

  // Finds out what the user selected, and uses that as the current answer.
  async function setAnswer(feeling, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage16")[index].style.borderColor  = 'yellow'
    setAnswerkey(feeling);
    setQuestion(false);
    const src = getVideo(feeling.url, login);
    await playVoiceAudio(src);
    setAnimaTalk(true);
  }

  // The HTML code for the practice
  return (
    <>
      {practiceVideo && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo}
          back='/understandfeelings'
          background={props.background}
          close={props.setDisplayPractice}
          ended={() => {
            setPracticeVideo(false);
            switch (props.module.currentday) {
              case 1:
                setupGame('mad')
                break;
              case 2:
                setupGame('sad')
                break;
              case 3:
                setupGame('nervous')
                break;
              default:
                setPractice(true);
                setQuestion(true);
                break;
            }
          }}
        />
      )}
      {practice && (
        <div className='Module12Practice' style={{ backgroundImage: `url(${props.background})`}}>
          <img
            alt=''
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>
            Which feelings do you want to practice?
          </h2>

          <div className='grid'>
            <div className='grid-item' onClick={() => setupGame('nervous')}>
              <img
                alt=''
                className='crabExpression15'
                src={Nervous_Confident}
              />
              <h3 className='practiceText12'>Nervous & Confident</h3>
            </div>
            <div className='grid-item' onClick={() => setupGame('sad')}>
              <img alt='' className='crabExpression15' src={Sad_happy} />
              <h3 className='practiceText12'>Sad & Happy</h3>
            </div>
            <div className='grid-item' onClick={() => setupGame('mad')}>
              <img alt='' className='crabExpression15' src={Mad_Calm} />
              <h3 className='practiceText12'>Mad & Calm</h3>
            </div>
          </div>
        </div>
      )}

      {matchGame1 && (
        <div className='Module12MatchGame' style={{ backgroundImage: `url(${props.background})`}}>
          <img
            className='back-btn-ftb'
            src={Exit}
            alt=''
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>
            What makes {who} {keyword}?
          </h2>
          <h3 className='practiceQuestion12'>
            I feel {keyword} when {changeAnswer}.
          </h3>
          {(
            <img
              className='greenCheckPractice12'
              src={greenCheck}
              style={{opacity : answerkey ? 1 : 0, pointerEvents : answerkey ? "auto" : "none"}}
              alt=''
              onClick={async () => {
                await sleep(500);
                if (ending) {
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  await playVoiceAudio(audio.src);
                  setAnimaTalk(true);
                  setChangeAnswer(answerkey.text);
                  setAnswerkey(null);
                  setClose(true);
                } else {
                  if (answerkey.feeling === keyword) {
                    if(firstTime){
                      setScore(score+1);
                    };
                    const audio = new Audio(
                      generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                    );
                    setChangeAnswer(answerkey.text);
                    setCheck(true);
                    await playVoiceAudio(audio.src);
                    setAnimaTalk(true);
                    setFirstTime(true);
                    setAnswerkey(null);
                  } else {
                    setFirstTime(false)
                    await playVoiceAudio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
                    setAnimaTalk(true);
                    setAnswerkey(null);
                  }
                }
              }}
            />
          )}
          <br />
          <img alt='' className='selectCrab12' src={selectImage} />
          <div className='gameGrid16'>
            <div className='optionImage16' onClick={() => setAnswer(option1, 0)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option1.img} />
                {/* <h4 className='practiceText12'>{option1.text}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option2, 1)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option2.img} />
                {/* <h4 className='practiceText12'>{option2.text}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option3, 2)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option3.img} />
                {/* <h4 className='practiceText12'>{option3.text}</h4> */}
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Always-mounted animal audio element */}
      <audio
          ref={animalAudioRef}
          src={animalVoice}
          preload='auto'
          playsInline
          onLoadedData={() => {
              const el = animalAudioRef.current;
              if (!el) return;
              // Only play when the animal image has loaded (displayAudio true)
              if (!displayAudio) return;
              const expected = expectedAnimalSrcRef.current;
              const currentSrc = el.currentSrc || el.src;
              if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
              el.currentTime = 0;
              el.play().catch((e) => {
                  const msg = String(e && e.message ? e.message : e);
                  if (!msg.includes('interrupted by a new load request')) {
                      console.log('animal audio play failed', e);
                  }
              });
          }}
          onPlay={() => { setAudioReady(true); }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayAudio(false);
            setDisplayAnimal(false);
            if (animateAnimal === props.specialMessage) {
              setDisplayInfluecer(true);
            } else if (animateAnimal === props.practiceConversation) {
              setConversation1(true);
            } else if (animateAnimal === props.awesomeJob) {
              updateScore();
              if (props.module.reviewIcon === false) {
                dispatch({ type: props.stepComplete, payload: 'practice' });
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayPractice(false);
            }
          }}
      />

      {practiceReview && (
        <CloudfrontVideoFormat
          source={reviewVideo}
          back='/unit3'
          background={props.background}
          close={props.setDisplayPractice}
          ended={() => {
            setPracticeReview(false);
            setDisplayCamera(true);
          }}
        />
      )}

      {displayCamera && !displayAfterVideo && (
        <VideoWebcamRecorder
          background={props.background}
          question={questionVideo}
          outputText={text}
          name={`understand_feelings_practice_video_${props.module.currentday}.mp4`}
          setDisplayCelebrateAfterVideo={setDisplayAfterVideo}
          setDisplayCelebrateRecord={setDisplayCamera}
          end={() => {
            playAnimalVoice(getVideo('appfiles/answer/answer_practice_special_message.mp3', login));
            setAnimateAnimal(props.specialMessage);
          }}
          voice={voice}
          setPlayVideo={setPlayVideo}
          close={props.setDisplayPractice}
        />
      )}

      {displayAfterVideo && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            alt=''
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {displayInfluecer && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                onEnded={() => (
                  setDisplayInfluecer(false),
                  setDisplayConversation(true),
                  setAnimateAnimal(props.practiceConversation),
                  playAnimalVoice(getVideo('appfiles/answer/answer_practice_watch_conversation.mp3', login))
                )}
                onError={() => (
                  setDisplayInfluecer(false),
                  setDisplayConversation(true),
                  setAnimateAnimal(props.practiceConversation),
                  playAnimalVoice(getVideo('appfiles/answer/answer_practice_watch_conversation.mp3', login))
                )}
                playsInline
              >
                <source src={influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}

          {conversation1 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setConversation2(true), setConversation1(false)
                )}
                onError={() => (
                  setConversation2(true), setConversation1(false)
                )}
                playsInline
              >
                <source src={greeting} type='video/mp4'></source>
              </video>
            </div>
          )}

          {conversation2 && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => (
                  setConversation3(true), setConversation2(false)
                )}
                onError={() => (
                  setConversation3(true), setConversation2(false)
                )}
                playsInline
              >
                <source src={greetingRespond} type='video/mp4'></source>
              </video>
            </div>
          )}

          {conversation3 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setConversation4(true), setConversation3(false)
                )}
                onError={() => (
                  setConversation4(true), setConversation3(false)
                )}
                playsInline
              >
                <source src={questionVideo} type='video/mp4'></source>
              </video>
            </div>
          )}

          {conversation4 && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => (
                  setConversation4(false), setConversation5(true)
                )}
                onError={() => (
                  setConversation4(false), setConversation5(true)
                )}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}

          {conversation5 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => {
                  setAnimateAnimal(props.awesomeJob);
                  playAnimalVoice(getVideo('appfiles/answer/answer_amazing_job.mp3', login));
                  setConversation5(false);
                }}
                onError={() => {
                  setAnimateAnimal(props.awesomeJob);
                  playAnimalVoice(getVideo('appfiles/answer/answer_amazing_job.mp3', login));
                  setConversation5(false);
                }}
                playsInline
              >
                <source src={acknowledge} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayAnimal && !audioReady && <img id="loading"  src={loading}/>}
          {displayAnimal && (
            <img
              alt=''
              className='animateCrab'
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateAnimal}
            />
          )}
        </div>
      )}

      {!animalTalk && question && (
        <audio autoPlay onEnded={() => setQuestion(false)}>
          <source src={introSound}></source>
        </audio>
      )}
      {/* Always-mounted audio for animalTalk */}
      <audio
        ref={talkAudioRef}
        src={voiceAudio}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = talkAudioRef.current;
          if (!el) return;
          if (!animalTalk) return;
          const expected = expectedTalkSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          el.currentTime = 0;
          el.play().catch((e) => {
            const msg = String(e && e.message ? e.message : e);
            if (!msg.includes('interrupted by a new load request')) {
              // eslint-disable-next-line no-console
              console.log('animalTalk audio play failed', e);
            }
          });
        }}
        onEnded={() => {
          setAnimaTalk(false);
          if (close) {
            if(!props.unit4){
              switch (props.module.currentday) {
                case 1:
                  setGreeting(getVideo('appfiles/answer/answer_greeting_5.mp4', login));
                  setAcknowledge(getVideo('appfiles/answer/answer_acknowledge_5.mp4', login));
                  setQuestionVideo(getVideo('appfiles/answer/answer_question_5.mp4', login));
                  setVoice(getVideo('appfiles/answer/answer_practice_record_5.mp3', login));

                  (async () => {
                    await GetUserVideo(
                      `userfiles/${props.module.StudentID}/feelings_practice_video_${props.module.currentday}.mp4`
                    ).then((data) => {
                      setGreetingRespond(data);
                    });
                    await GetUserVideo(
                      `influencers/${login.influencerid}/answer_video_message.mp4`
                    ).then((data) => {
                      setInfluencerVideo(data);
                    });
                    setText('Say, "My favorite color is ________."');
                  })();
                  setReviewVideo('6e8c35006cb995722b31d50d6f5d/480.m3u8');
                  break;
                case 2:
                  setGreeting(getVideo('appfiles/answer/answer_greeting_6.mp4', login));
                  setAcknowledge(getVideo('appfiles/answer/answer_acknowledge_6.mp4', login));
                  setQuestionVideo(getVideo('appfiles/answer/answer_question_6.mp4', login));
                  setVoice(getVideo('appfiles/answer/answer_practice_record_6.mp3', login));

                  (async () => {
                    await GetUserVideo(
                      `userfiles/${props.module.StudentID}/feelings_practice_video_${props.module.currentday}.mp4`
                    ).then((data) => {
                      setGreetingRespond(data);
                    });
                    await GetUserVideo(
                      `influencers/${login.influencerid1}/answer_video_message.mp4`
                    ).then((data) => {
                      setInfluencerVideo(data);
                    });
                    setText('Say, "My favorite animal is ________."');
                  })();
                  setReviewVideo('6e8c35006cb995722b31d50d6f5d/480.m3u8');
                  break;
                case 3:
                  setGreeting(getVideo('appfiles/answer/answer_greeting_7.mp4', login));
                  setAcknowledge(getVideo('appfiles/answer/answer_acknowledge_7.mp4', login));
                  setQuestionVideo(getVideo('appfiles/answer/answer_question_7.mp4', login));
                  setVoice(getVideo('appfiles/answer/answer_practice_record_7.mp3', login));

                  (async () => {
                    await GetUserVideo(
                      `userfiles/${props.module.StudentID}/feelings_practice_video_${props.module.currentday}.mp4`
                    ).then((data) => {
                      setGreetingRespond(data);
                    });
                    await GetUserVideo(
                      `influencers/${login.influencerid2}/answer_video_message.mp4`
                    ).then((data) => {
                      setInfluencerVideo(data);
                    });
                    setText('Say, "My favorite food is ________."');
                  })();
                  setReviewVideo('549b0403690da3f0f978badd93b2/480.m3u8');
                  break;
                default:
                  updateScore();
                  if (props.module.reviewIcon === false) {
                    dispatch({ type: props.stepComplete, payload: 'practice' });
                  }
                  props.module.sectionCompleted = props.module.sectionCompleted + 1
                  props.setDisplayPractice(false);
                  break;
              }
              setMatchGame1(false);
              setPracticeReview(true);
            }
            else{
              updateScore();
              if (props.module.reviewIcon === false) {
                dispatch({ type: props.stepComplete, payload: 'practice' });
              }
              props.setDisplayPractice(false);
            }
          } else if (check) {
            if (keyword === 'nervous') {
              setupGame('confident');
            } else if (keyword === 'confident') {
              setupGame('nervous_confident');
            } else if (keyword === 'sad') {
              setupGame('happy');
            } else if (keyword === 'happy') {
              setupGame('sad_happy');
            } else if (keyword === 'mad') {
              setupGame('calm');
            } else if (keyword === 'calm') {
              setupGame('mad_calm');
            }
          }
        }}
      />
    </>
  );
};
export default UnderstandFeelingsPractice;
